// This file is the same as bsw-server-common/src/utils/regex.ts
// TODO: Make this a NPM package so we can share it between server and client
export default {
    // By intention only matches lowercase emails
    email: /^([a-z0-9_-]+[.+])*[a-z0-9_-]+@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/,
    databaseId: /^[a-zA-Z0-9]{12}$/,
    token: /^[a-zA-Z0-9]{24}$/,
    // BootstrapRadar ID
    bsrId: /^bip:\/\/bootstrapworks\/user\/[a-zA-Z0-9]{12}$/,
    // Matches valid date in YYYY-MM-DD format. Will accept leap year days, eg 2020-02-29.
    // https://stackoverflow.com/a/38059380/1959584
    //
    // NOTE: This regex match '2012-12-22222222', which is not inteded
    //
    // date: /^((18|19|20)[0-9]{2}-(0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|(18|19|20)[0-9]{2}-(0[469]|11)-(0[1-9]|[12][0-9]|30)|(18|19|20)[0-9]{2}-(02)-(0[1-9]|1[0-9]|2[0-8])|(((18|19|20)(04|08|[2468][048]|[13579][26]))|2000)-(02)-29$/,
    // Matches a date-like string (including for example '9999-99-99')
    dateLike: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/,
    // Matches a trimmed string. Only space is allowed within the string, no other
    // white space characters (eg. not tab, new line, etc.). The string may be
    // empty.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
    trimmedString: /^((\S[\S ]*)?\S)?$/,
    // Same as 'trimmedString' but only matches lower case alphabet
    trimmedLowerCaseString: /^(([^\sA-Z]([^\sA-Z]| )*)?[^\sA-Z])?$/,
    // Matches a string that contains white space beyond regular spaces
    specialWhiteSpace: /[^\S ]+/,
    // Matches strings that starts with http or https.
    // Note: this regex does not, in any other way, validate the url.
    // The string 'http://xxxxxxxxxxxxxx' as well as the string 'http://' will pass a regex.url.test()
    url: /^https?:\/\/(.*)/,
};
//# sourceMappingURL=regex.js.map